import { omsOrderDataTransformer } from './omsOrderDataTransformer';
import { OmsAddressTransformer } from './omsAddressTransformer';
import { OmsItemTransformer } from './omsItemTransformer';
import { OmsAddressType, PurchasedItemType } from './@types';
import { priveDataTransformer } from './priveTransformer';


export const PaymentSuccessTransformer = (response: {
  couponCode: string,
  customerDetails: OmsAddressType,
  giftCardOrder: boolean,
  itemsCount: number,
  itemsQty: number,
  orderNo: string,
  orderSummary: OmsOrderSummaryType,
  pakkaPromise: boolean,
  paymentMethod: string,
  paymentType: string,
  refferalView: {
    aspectRatio: string,
    image: string,
    isActive: number,
    title: string,
  },
  itemList: PurchasedItemType[],
  futureConfirmationCoupon: string[];
  futureDeliveredCoupon: string[];
  firstPurchase: boolean,
  cod_delay_message: string,
  totalRewardPointsToBeCredited:number,
  baseRewardPoints: number,
  priveTier: string,
  multiplier: number,
  multiplierDesc: string
}) => ({
  couponCode: response?.couponCode,
  giftCardOrder: response.giftCardOrder,
  codDelayMessage: response.cod_delay_message || '',
  items: OmsItemTransformer(response.itemList || []),
  orderData: omsOrderDataTransformer(response || {}),
  shippingAddress: OmsAddressTransformer(response.customerDetails),
  futureConfirmationCoupon: response.futureConfirmationCoupon,
  futureDeliveredCoupon: response.futureDeliveredCoupon,
  firstPurchase: response.firstPurchase || false,
  prive: priveDataTransformer(response || {}),
});
